import { trpc } from '@/shared/api';

interface StoreProductDetailQueryOptions {
  readonly enabled?: boolean;
}

/** 스토어 공개 상품 상세(products.get). 미공개·미존재는 NOT_FOUND 로 온다. */
export const useStoreProductDetailQuery = (
  productId: string,
  options: StoreProductDetailQueryOptions = {},
) =>
  trpc.products.get.useQuery(
    { id: productId },
    {
      enabled: options.enabled ?? true,
      // 존재하지 않는 상품(NOT_FOUND)은 재시도해도 결과가 같다.
      retry: false,
    },
  );
